export enum CronEditorMode {
  unselected = 'unselected',
  repeatMinute = 'repeat-minute',
  repeatHour = 'repeat-hour',
}
